import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';

import types from '../types';
import actions from '../actions';


import { getIOFAQtDataApi } from '../../api';


export function* getFAQDataFlow(action) {
  try {
    const response = yield call(getIOFAQtDataApi,
      action.opts.is1031,
      action.opts.isReit,
      action.opts.id);
    yield put(
      actions.getFAQDataSucceeded(response.data),
    );
  } catch (error) {
    yield put(
      actions.getFAQDataFailed(error),
    );
  }
}

export function* watchGetFAQDataRequested() {
  yield takeLatest(
    types.GET_IO_FAQ_DATA_REQUESTED,
    getFAQDataFlow,
  );
}

export default watchGetFAQDataRequested;
